<script>
  import responsive from '@/js/utils/responsive.js';
  import { onMount } from 'svelte';

  export let title;

  $: innerHeight = 0;

  let innerWidth, heroTitleEl;
  let hero3dtransform;
  let xsScreen = false;

  const cumulativeOffset = (element) => {
    var top = 0,
      left = 0;
    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);

    return {
      top: top,
      left: left,
    };
  };

  export function update(event) {
    if (innerWidth <= responsive.m) {
      return;
    }
    const x =
      ((event.clientX - cumulativeOffset(heroTitleEl).left - 350 / 2) * -1) /
      100;
    const y =
      ((event.clientY - cumulativeOffset(heroTitleEl).top - 350 / 2) * -1) /
      100;

    const matrix = [
      [1, 0, 0, -x * 0.00001],
      [0, 1, 0, -y * 0.00001],
      [0, 0, 1, 1],
      [0, 0, 0, 1],
    ];

    hero3dtransform = matrix.toString();
  }

  function handleScreenSize() {
    xsScreen = innerHeight < responsive.extraSmallHeight;
  }

  onMount(() => {
    handleScreenSize();
  });
</script>

<svelte:window bind:innerWidth bind:innerHeight />

<div class="title-wrap">
  {#if innerWidth > responsive.m && !xsScreen}
    <h1
      class="title"
      bind:this={heroTitleEl}
      style={`transform: matrix3d(${hero3dtransform});`}
    >
      {@html title}
    </h1>
  {:else if xsScreen}
    <h1 class="title title--small">{@html title}</h1>
  {:else}
    <h1 class="title">{@html title}</h1>
  {/if}
</div>

<style lang="scss">
  .title-wrap {
    display: flex;
    justify-content: flex-end;

    padding: {
      right: 5.5rem;
    }
  }

  .title {
    @include resp-max('s') {
      font-size: 5.3rem;
    }
    @include resp-range('s', 'm') {
      font-size: 10rem;
    }
    @include resp-min('m') {
      font-size: 15rem;
    }

    display: inline-block;
    color: var(--aqua-1);
    letter-spacing: -0.03em;
    line-height: 1;

    text-align: right;

    &--small {
      @include resp-max('s') {
        font-size: 5.3rem;
      }
      @include resp-range('s', 'm') {
        font-size: 5.3rem;
      }
      @include resp-min('m') {
        font-size: 10rem;
      }
    }
  }
</style>
